export const thongBao = {
  title: 'Notifications',
  markAllRead: 'Mark all read',
  deleteAll: 'Delete all',
  empty: 'No notifications',
  loadError: 'Could not load notifications',
  confirmDeleteAll: 'Delete all your notifications?',
  ariaLabel: 'Notifications',
  unreadBadge: '{count} unread',
  meta: '{type} · {action}',
  byUser: 'By {user}',
  xem: 'View',
  xoa: 'Delete notification',
  filterAll: 'All',
  filterUnread: 'Unread',
  markAllReadShort: 'Read all',
  loadMore: 'Load more',
  xemTatCa: 'View all notifications',
  caiDat: 'Notification settings',
  loai: {
    CODONHANGMOI: 'New order',
    CODONHANGCANNHAT: 'Order to pick',
    CODONHANGCANKIEMTRA: 'Order to check',
    CODONHANGCANDONGGOI: 'Order to pack',
    CODONHANGCANDIEUPHOI: 'Order to dispatch',
    CODONHANGCANGIAO: 'Order to deliver',
    DONHANG_DUOC_SUA: 'Order info edited',
    CANHBAO_DOI_SOAT: 'Order not yet in operations',
    GIAO_HANG_THANH_CONG: 'Delivery succeeded',
    GIAO_HANG_THAT_BAI: 'Delivery failed',
    HOA_DON_MOI: 'New invoice',
    HOA_DON_SUA: 'Invoice edited',
    HOA_DON_HUY: 'Invoice cancelled or deleted',
    PHIEU_THU_CHI_CHO_DUYET: 'Receipt/payment awaiting approval',
    PHIEU_THU_CHI_DA_DUYET: 'Receipt/payment approved',
    PHIEU_THU_CHI_TU_CHOI: 'Receipt/payment rejected',
    YCX_CAN_XU_LY: 'Invoice request to process',
    CHUYEN_HANG_DEN: 'Incoming stock transfer',
    DON_HOA_TOC: 'New express (Hỏa Tốc) order',
    DON_SHIP_HUY: 'Shipper cancelled — reassign needed',
    DON_QUA_HAN_GIAO: 'Past ship-by deadline — not picked up',
  },
  phanHe: {
    KHO: 'Warehouse',
    BAN_HANG: 'Sales',
  },
  nhomLoai: {
    donHang: 'Orders',
    canhBao: 'Alerts',
    hoaDon: 'Invoices',
    giaoHang: 'Delivery',
    soQuy: 'Cash book',
    xuatHoaDon: 'Invoicing',
    chuyenHang: 'Stock transfer',
    banOnline: 'Online orders',
  },
  caiDatTrang: {
    moTa: 'Turning a type off hides popups / mobile push; notifications are still kept in the list.',
    trinhDuyet: 'On this browser',
    trinhDuyetMoTa: 'Applies only to the current browser and is not synced to other devices.',
    thietBi: 'Device',
    thongBaoPhanHe: '{phanHe} notifications',
    tomTat: 'Receiving {nhan}/{tong}',
    guiThu: 'Send test',
    thuNoiDung: 'This is a test notification.',
    amThanh: 'Play a sound for new notifications',
    amThanhMoTa: 'A short "ting" whenever a new notification pops up.',
    heThong: 'Show system notifications while on another tab',
    heThongMoTa: 'Notifications appear in the screen corner even while you use another tab or app.',
    heThongBiChan: 'The browser is blocking notifications — allow them in site settings.',
    heThongKhongHoTro: 'This browser does not support system notifications.',
    loaiThongBao: 'Notification types',
    khongCoQuyen: 'Your account has no permission to receive notifications.',
    batTatCa: 'Turn all on',
    tatTatCa: 'Turn all off',
    dangNhan: 'On',
    daTat: 'Off',
    tatDen: 'Off until {thoiGian}',
    tamTat: 'Snooze',
    tat1Gio: 'Off for 1 hour',
    tatDen8hSang: 'Off until 8:00 AM',
    tatDenKhiBatLai: 'Off until turned back on',
    batLai: 'Turn on now',
    luuLoi: 'Could not save notification settings',
    taiLoi: 'Could not load notification settings',
    phamVi: 'Projects for notifications',
    phamViHint: 'Only enabled projects · tap a row for temporary assist (web)',
    phamViTieuDe: 'Projects for notifications (web)',
    phamViMoTa:
      'Web only. Turning a project off hides popups; items stay in the list. Mobile is configured separately in the app.',
    phamViTomTat: 'Receiving {nhan}/{tong} projects',
    phamViHoTroTam: 'Assisting: {danhSach}',
    phamViHoTroDen: 'Assist until {thoiGian}',
    phamViHoTro: 'Temporary assist',
    phamViDen1Gio: 'For 1 hour',
    phamViDen8h: 'Until 8:00 AM',
    phamViDenHetNgay: 'Until end of today',
    phamViTatChiNhanh: 'Stop receiving this project',
    phamViTaiLoi: 'Could not load notification scope',
    phamViLuuLoi: 'Could not save notification scope',
    phamViTrong: 'No projects assigned to this account.',
    loaiHint: 'Off blocks popups · tap a row to snooze',
    amThanhNgan: 'Play sound',
    heThongNgan: 'OS notifications',
  },
}
